import { JourneyAlias } from '@hc-frontend/core-types';
import {
  createErrorOperationResult,
  createSuccessOperationResult,
} from '@hc-frontend/core-utils-business-operation';
import type { Optional } from '@hc-frontend/core-utils-types';

import type { GetProductRepository } from '../../domain/repositories/get-product-repository';

function tryGetJourneyAliasFromPathname(
  pathname: string,
  experiments: Record<string, string | undefined> = {},
): Optional<JourneyAlias> {
  if (pathname.includes('/healthcare-insurance/survey/')) {
    if (experiments['mp_2416_remove_tobacco_plate'] === 'variant') {
      return JourneyAlias.Enum[112];
    }

    return JourneyAlias.Enum.HEALTH_DEFAULT;
  }
  if (pathname.includes('/medicare/survey/')) {
    return JourneyAlias.Enum.MEDICARE_GENERIC;
  }
  if (pathname.includes('/medicare-supplement/survey/')) {
    return JourneyAlias.Enum.MEDICARE_SUPPLEMENT;
  }
  if (pathname.includes('/medicare-advantage/survey/')) {
    return JourneyAlias.Enum.MEDICARE_ADVANTAGE;
  }
  return undefined;
}

export function getProductFromPathnameFactory(): Pick<
  GetProductRepository,
  'getProductFromPathname'
> {
  return {
    getProductFromPathname: async (experiments) => {
      try {
        const { headers } = await import('next/headers');
        const pathname = (await headers()).get('x-pathname');
        if (!pathname) {
          throw new Error('x-pathname is undefined');
        }

        const optionalJourneyAlias = tryGetJourneyAliasFromPathname(
          pathname,
          experiments,
        );

        if (!optionalJourneyAlias) {
          throw new Error('It is not a survey pathname');
        }

        return createSuccessOperationResult(optionalJourneyAlias);
      } catch (error) {
        return createErrorOperationResult({
          errors: [{ code: 'failedToGetProduct', rootCause: error as Error }],
        });
      }
    },
  };
}
